"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _reactFela = require("react-fela");

var _base = require("../../base");

var _util = require("../../../util");

var _ButtonSocial = require("./ButtonSocial.style");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ButtonSocial = /*#__PURE__*/React.forwardRef(({
  as: Component = 'button',
  size = 'large',
  type,
  variant = 'google',
  width = 'inline',
  isLoading = false,
  children = '',
  disabled = false,
  ...otherProps
}, ref) => {
  const getRenderedIcon = () => {
    const sizeIcon = size === 'large' ? 'small' : 'inline';

    switch (variant) {
      case 'google':
        return (0, _pragma.createFelaElement)(_base.SocialGoogleIcon, {
          size: sizeIcon
        });

      case 'googleAlt':
        return disabled ? (0, _pragma.createFelaElement)(_base.SocialGoogleIcon, {
          size: sizeIcon
        }) : (0, _pragma.createFelaElement)(_base.SocialGoogleColor, {
          size: sizeIcon
        });

      case 'apple':
        return (0, _pragma.createFelaElement)(_base.SocialAppleIcon, {
          size: sizeIcon
        });

      default:
        return (0, _pragma.createFelaElement)(_base.SocialGoogleIcon, {
          size: sizeIcon
        });
    }
  };

  const fela = (0, _reactFela.useFela)();
  const theme = fela.theme;
  const defaultType = Component === 'button' && !type ? 'button' : undefined;
  const variantTheme = theme.buttonSocial[variant];
  return (0, _pragma.createFelaElement)(Component, _extends({
    css: _ButtonSocial.css,
    cssProps: {
      size,
      variant
    },
    ref: ref,
    type: defaultType,
    variant: variant,
    disabled: disabled
  }, otherProps), isLoading ? (0, _pragma.createFelaElement)(_base.Loading, {
    color: (0, _util.color)(theme, variantTheme.loadingColor)
  }) : (0, _pragma.createFelaElement)(React.Fragment, null, (0, _pragma.createFelaElement)(_base.View, {
    as: "span",
    cssProps: {
      size
    },
    css: _ButtonSocial.cssIcon,
    margin: [0, 'small', 0, 0]
  }, getRenderedIcon()), children));
});
ButtonSocial.displayName = 'ButtonSocial';
var _default = ButtonSocial;
exports.default = _default;
//# sourceMappingURL=ButtonSocial.js.map